import React from 'react';
import { useGoogleReview } from '../contexts/GoogleReviewContext';
import { useMilestoneReview } from '../contexts/MilestoneReviewContext';
import { GoogleReviewModal } from './ToxicDetector/GoogleReviewModal';
import { MilestoneReviewModal } from './ToxicDetector/MilestoneReviewModal';
export function GlobalModals() {
  const {
    isModalOpen: isGoogleOpen,
    closeModal: closeGoogle
  } = useGoogleReview();
  const {
    isModalOpen: isMilestoneOpen,
    closeModal: closeMilestone,
    currentMilestone,
    scanCount
  } = useMilestoneReview();
  return <>
      <GoogleReviewModal isOpen={isGoogleOpen} onClose={closeGoogle} data-id="element-1093" />
      <MilestoneReviewModal isOpen={isMilestoneOpen} onClose={closeMilestone} milestone={currentMilestone || 20} scanCount={scanCount} data-id="element-1094" />
    </>;
}